import { cn } from "@newxsystems/shared";
import { GroundCommonContent } from "../../../../modules/content/components/GroundCommonContent/GroundCommonContent";
import { GroundRichText } from "../../../../modules/content/components/GroundRichText/GroundRichText";
import { GroundSection } from "../../../../modules/content/components/GroundSection/GroundSection";
import type { IStatsBlockProps } from "./StatsBlock.props";

const columns = {
  1: "grid-cols-1",
  2: "grid-cols-1 sm:grid-cols-2",
  3: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3",
  4: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
} as const;

export const StatsBlock = ({
  alignment,
  anchorId,
  buttons,
  columnCount,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
}: IStatsBlockProps) => {
  if (!items?.length) return null;

  return (
    <GroundSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-10 md:gap-14">
        <GroundCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div
          className={cn("grid border-l border-t border-weathered-steel", columns[columnCount || 3])}
        >
          {items.map((item, index) => (
            <article
              className={cn(
                "border-b border-r border-weathered-steel bg-background px-5 py-7 sm:px-6",
                index === 0 && "bg-primary text-primary-foreground",
              )}
              key={index}
            >
              <p
                className={cn(
                  "font-ground-display text-5xl font-bold leading-none tracking-[-0.03em] text-foreground md:text-6xl",
                  index === 0 && "text-primary-foreground",
                )}
              >
                {item.value}
              </p>
              <h3
                className={cn(
                  "mt-5 font-ground-mono text-sm font-medium text-foreground",
                  index === 0 && "text-primary-foreground",
                )}
              >
                {item.label}
              </h3>
              {item.description ? (
                <GroundRichText
                  className={cn(
                    "mt-3 max-w-[32ch] text-base text-basalt md:text-lg",
                    index === 0 &&
                      "text-primary-foreground [&_a]:text-primary-foreground [&_blockquote]:border-primary-foreground/40 [&_blockquote]:text-primary-foreground",
                  )}
                  content={item.description}
                />
              ) : null}
            </article>
          ))}
        </div>
      </div>
    </GroundSection>
  );
};

StatsBlock.displayName = "Block::StatsBlock";
